import styled from 'styled-components';

export const UploadXlsxForm = styled.div`
    display: flex;
    width: 220px;
    padding: 0;
    
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 10px 20px 10px 10px;
    }

    .container > h6{
        text-align: center;
        font-size: 18px;
        color: #F28F1A;
    }

    .input-container{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;;
        height: initial;
        gap: 10px;
    }

    .input-container > p{
        max-width: 110px;
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .input-container > label{
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        padding: 5px;
        width: 25px;
        height: 25px;
        text-align: center;
        background-color: #DC4405;
        color: #FFF;
        cursor: pointer;
    }

    .input-container > input {
        display:none;
    }

    .button-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .button-container > button{
        padding: 5px;
        background-color: #00A8FF;
        border: 0;
        border-radius: 9px;
        color: #FFF;
        font-weight: bold;
    }

    .button-container > a {
        background-color: green;
        color: #fff;
        padding: 5px 10px;
        border-radius: 10px;
    }
`